<template>
  <div>
    <div class="pay-select">
      <div class="year">
        <span>{{ $t('1591') }}</span>
        <el-date-picker
          class="picker"
          v-model="pay_month"
          value-format="yyyy-MM"
          size="small"
          :clearable="false"
          type="month"
          @change="getSentList"
        >
        </el-date-picker>
        <i class="pay-icon el-icon-arrow-down"></i>
      </div>
    </div>
    <div class="wrap1-content" v-if="wageLength" v-loading.lock="loading">
      <ul>
        <li v-for="item in wageList" :key="item.payroll_scheme_id">
          <div class="pay-info">
            <p class="tag">
              <label class="name">{{ item.name }}</label>
              <el-tag size="mini">{{ item.settlement_type_text }}</el-tag>
              <el-tag size="mini">{{ item.tax_deduction_status_text }}</el-tag>
            </p>
            <p>
              <!-- 子项目名称 -->
              <label>{{ $t('payroll_wage_16') }}：</label>
              <span class="info">{{ item.sub_project_name }}</span>
            </p>
            <p class="tag">
              <!-- 已发送 -->
              <label>{{ $t('pay_slip_20') }}：</label>
              <span class="info">{{ item.send_success_count }}/{{ item.send_count }}</span>
              <el-tag size="mini" v-if="!Number(item.status) && Number(item.send_way_app)">App</el-tag>
              <el-tag size="mini" v-if="Number(item.status) === 1">{{ $t('pay_slip_33') }}</el-tag>
              <el-tag size="mini" v-if="Number(item.status) === 2">{{ $t('pay_slip_34') }}</el-tag>
              <el-tag size="mini" v-if="Number(item.send_way_email)">{{ $t('personal_email') }}</el-tag>
              <el-tag size="mini" v-if="Number(item.send_way_exmail)">{{ $t('business_mailbox') }}</el-tag>
            </p>
          </div>
          <div class="btn2">
            <p>
              <span v-if="Number(item.status) === 2">{{ $t('pay_slip_52', { key: item.recall_staff_name }) }}</span>
            </p>
            <div>
              <!-- 撤回 -->
              <el-button
                size="small"
                v-if="!Number(item.status) && Number(item.send_way_app) && $p('menu.payroll.scheme.delete')"
                @click="onCancel(item)"
                >{{ $t('pay_slip_55') }}</el-button
              >
              <!-- 查看设置 -->
              <el-button size="small" @click="goToDetail(item, '4')"> {{ $t('pay_slip_9') }}</el-button>
              <!-- 查看发送结果 -->
              <el-button size="small" @click="sendResults(item)">{{ $t('pay_slip_19') }}</el-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="not-data" v-else>
      <img src="@/assets/img/icon-not.png" alt="" />
      <span>{{ $t('no_data') }}</span>
    </div>
  </div>
</template>

<script>
import { getSentList, getSentPayMonth, recallSent } from 'api/payroll/pay-slip'
export default {
  data() {
    return {
      loading: true,
      pay_month: this.$route.query.month3 || '',
      wageLength: -1,
      wageList: [] // 方案列表
    }
  },
  async mounted() {
    if (!this.$route.query.month3) await this.getSentPayMonth()
    await this.getSentList()
  },
  methods: {
    async getSentPayMonth() {
      const res = await getSentPayMonth()
      if (res && res.code === 1) this.pay_month = res.data[0]?.child[0] || this.$util.fmtDate('yyyy-MM')
    },
    async getSentList() {
      if (!this.pay_month) {
        this.$message.warning(this.$t('payroll_salary_28'))
        return
      }
      // 工资条列表
      this.loading = true
      this.$router.push({ query: { active: '3', month3: this.pay_month } })
      getSentList({ pay_month: this.pay_month })
        .then(res => {
          if (res && res.code === 1) this.wageList = res.data
          this.wageLength = res.data.length
        })
        .finally(() => (this.loading = false))
    },
    onCancel(item) {
      // 待发子项目选择工资条
      this.$confirm(this.$t('pay_slip_32'), this.$t('pay_slip_31'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
        .then(async () => {
          recallSent({ payslip_id: item.payslip_id }).then(res => {
            if (res && res.code === 1) this.getSentList()
            this.$message.success(this.$t('pay_slip_36'))
          })
        })
        .catch(() => {})
    },
    goToDetail(item, state) {
      // 跳转配置页
      this.$router.push({
        path: '/payroll/setpay-pay-slip/' + item.payslip_id,
        query: {
          ...this.$route.query,
          payslip_scheme_id: item.id,
          type: item.settlement_type,
          tax_deduction_status: item.tax_deduction_status,
          state
        }
      })
    },
    sendResults(item) {
      this.$router.push({
        path: '/payroll/pay-send-results/' + item.payslip_id,
        query: {
          ...this.$route.query,
          payslip_scheme_id: item.id,
          type: item.settlement_type,
          tax_deduction_status: item.tax_deduction_status
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1-content {
  width: 100%;
  overflow: hidden;
  ul {
    width: 100%;
    overflow-x: auto;
  }
  li {
    min-width: 1000px;
    padding: 24px;
    height: auto;

    align-items: flex-end;
    .pay-info {
      display: block;
      p {
        line-height: 28px;
        overflow: hidden;
        display: flex;
        &.tag {
          align-items: center;
        }
        &:first-child {
          padding-bottom: 8px;
        }
        .name {
          font-weight: 500;
          font-size: 16px;
          color: #262626;
          padding-right: 8px;
          max-width: 450px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        label {
          height: 100%;
          font-weight: 400;
          font-size: 14px;
          color: #262626;
        }
        .info {
          height: 100%;
          font-weight: 400;
          font-size: 14px;
          color: #595959;
          padding-right: 12px;
          max-width: 450px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    .btn2 {
      height: 92px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p {
        color: #8c8c8c;
        font-size: 12px;
        font-weight: normal;
        height: 24px;
        line-height: 24px;
        text-align: right;
      }
    }
  }
}
.pay {
  &-select {
    height: 60px;
    .year {
      display: inline-block;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      position: relative;
      span {
        color: #8c8c8c;
        position: absolute;
        left: 12px;
        top: 8px;
        z-index: 2;
      }
      .pay-icon {
        position: absolute;
        right: 12px;
        top: 8px;
        z-index: 2;
      }
      /deep/.picker {
        max-width: 256px;
        font-size: 14px;
        .el-input__inner {
          padding-left: 100px;
          padding-right: 0px;
          cursor: pointer;
        }
        .el-input__prefix {
          display: none;
        }
      }
    }
    &-left {
      padding: 14px 0;
      flex: 1;
    }
    &-right {
      padding: 14px 0;
      .btn-title {
        color: #5D51DA;
        border-color: #5D51DA;
      }
    }
  }
  /deep/ .el-radio-group {
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #fff;
      color: #5D51DA;
    }
  }
}
</style>
